<script setup lang="ts">
import { onMounted, ref } from 'vue';
import AppButton from '@/components/v2/AppButton.vue';
import { useSessionExpiry } from '@/composables/useSessionExpiry';

const heading = ref<HTMLHeadingElement>();

function signIn(): Promise<void> {
  return useSessionExpiry().redirectToLogin('/');
}

onMounted(() => heading.value?.focus());
</script>

<template>
  <div class="mx-auto flex max-w-xl flex-col items-center gap-4 px-4 pt-[15vh] text-center">
    <h1
      ref="heading"
      tabindex="-1"
      class="outline-none"
      data-test="title">
      You've been signed out
    </h1>
    <p>You've signed out of the CAC Platform. You can close this tab, or sign in again to keep working.</p>
    <AppButton
      primary
      @click="signIn">
      Sign in again
    </AppButton>
  </div>
</template>
